export const ghavanin = {
  fa: `<h1>آیین‌نامه</h1>\n` +
      `\n` +
      `    <p><strong>کاربر گرامی،</strong> قبل از استفاده لازم است قوانین و شرایط زیر را مطالعه نمایید.</p>\n` +
      `\n` +
      `    <h2>عمومی</h2>\n` +
      `    <p>عضویت و ایجاد حساب کاربری در سایت ترمینال ادز رایگان است. اشخاص برای عضویت باید به بخش عضویت مراجعه کنند. ثبت‌نام و تکمیل آن به منزلهٔ آگاهی و پذیرش کامل قوانین و مقررات ترمینال ادز است.</p>\n` +
      `\n` +
      `    <p>هر شخصی که به هر میزان از خدمات ترمینال ادز استفاده کند، به معنای پذیرش کامل قوانین و مقررات سایت است.</p>\n` +
      `\n` +
      `    <p>هر شخص فقط می‌تواند یک حساب کاربری داشته باشد. در صورت مشخص شدن داشتن چند حساب، ترمینال ادز می‌تواند آن‌ها را حذف و دسترسی کاربر را قطع نماید. کاربر حق اعتراض ندارد.</p>\n` +
      `\n` +
      `    <p>افراد باید از اطلاعات هویتی واقعی خود استفاده کنند. ترمینال ادز در صورت تخلف مسئولیتی ندارد.</p>\n` +
      `\n` +
      `    <p>اگر مشخص شود فردی با حساب جعلی خرید یا استفاده کرده است، ترمینال ادز می‌تواند حساب را حذف نماید و وجه پرداختی بازگردانده نخواهد شد.</p>\n` +
      `\n` +
      `    <p>سایت ترمینال ادز تلاش می‌کند صفحات و مطالب خود را به‌روزرسانی کند، اما می‌تواند آزادانه صفحاتی را حذف یا موقت/دائم غیرفعال کند. کاربران حق اعتراض ندارند.</p>\n` +
      `\n` +
      `    <p>اطلاعات کاربران نزد سایت محفوظ است و ترمینال ادز تمام تلاش خود را برای حفظ آن‌ها انجام می‌دهد.</p>\n` +
      `\n` +
      `    <h2>مسئولیت‌های کاربر</h2>\n` +
      `    <p>کاربر باید اطلاعات خود مثل نام کاربری، اطلاعات تماس و رمز عبور را محرمانه نگه دارد. در صورت افشا، مسئولیت کامل بر عهدهٔ کاربر است و سایت هیچ مسئولیتی ندارد.</p>\n` +
      `\n` +
      `    <p>کاربر نباید حساب خود را در اختیار دیگران قرار دهد. ترمینال ادز فقط به مالک حساب خدمات می‌دهد. مشکلات ناشی از استفادهٔ همزمان یا انتقال حساب، مسئولیتش بر عهدهٔ کاربر است و ترمینال ادز مسئولیتی ندارد.</p>\n` +
      `\n` +
      `    <h2>ارتباطات</h2>\n` +
      `    <p>با ثبت‌نام یا ارائهٔ ایمیل/شماره تلفن، کاربر به سایت اجازه می‌دهد در مواقع لازم پیامک یا ایمیل ارسال کند. کاربر می‌تواند انصراف دهد.</p>\n` +
      `\n` +
      `    <p>اطلاعات تماس ثبت‌شده توسط کاربر تنها مرجع معتبر است و مکاتبات صرفاً از طریق آن انجام می‌شود.</p>\n` +
      `\n` +
      `    <p>در صورت تغییر اطلاعات، کاربر باید سایت را مطلع کند. در غیر این صورت سایت مسئولیتی ندارد.</p>\n` +
      `\n` +
      `    <p>کاربر می‌تواند از طریق صفحه «تماس با ما» با سایت در ارتباط باشد.</p>\n` +
      `\n` +
      `    <h2>قوانین کلی خدمات ترمینال ادز</h2>\n` +
      `    <ul>\n` +
      `      <li>مخاطبین تبلیغ باید قوانین و دستورالعمل‌های جمهوری اسلامی ایران را رعایت کنند.</li>\n` +
      `      <li>رعایت قوانین دولت الکترونیک، امنیت اینترنت و محرمانگی الزامی است.</li>\n` +
      `      <li>کاربر متعهد به رعایت قوانین مصوب آینده نیز هست.</li>\n` +
      `      <li>مسئولیت انتشار آگهی غیرمجاز و جبران خسارت‌ها بر عهدهٔ کاربر است.</li>\n` +
      `      <li>ترمینال ادز می‌تواند بنا به نیاز یا درخواست مراجع قانونی تبلیغات را مسدود یا حذف کند.</li>\n` +
      `    </ul>\n` +
      `\n` +
      `    <h2>محتوای تبلیغات — اصول پنج‌گانه</h2>\n` +
      `    <ol>\n` +
      `      <li>مغایر با اسلام و قانون اساسی جمهوری اسلامی ایران نباشد.</li>\n` +
      `      <li>باعث تشویش اذهان عمومی نشود.</li>\n` +
      `      <li>مخل نظم و آرامش عمومی نباشد.</li>\n` +
      `      <li>به اخلاق عمومی آسیب نزند.</li>\n` +
      `      <li>با سیاست‌های فرهنگی، اجتماعی و اقتصادی کشور مغایرت نداشته باشد.</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <p>کاربر باید اطلاعات صحیح وارد کند. در صورت درج اطلاعات نادرست، ترمینال ادز می‌تواند حساب را مسدود و اقدامات قانونی لازم را انجام دهد.</p>\n` +
      `\n` +
      `    <p>شماره‌های ثبت‌شده نزد سامانه قابل انتقال نیستند و فقط توسط خود کاربر قابل استفاده‌اند.</p>\n` +
      `\n` +
      `    <h2>مدارک الزامی</h2>\n` +
      `    <p>برای استفاده از سامانه، مدارک زیر باید یکسان باشند:</p>\n` +
      `    <ol>\n` +
      `      <li>کد ملی</li>\n` +
      `      <li>شماره مرتبط با کد ملی</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <h2>نکته مهم دربارهٔ پرداخت‌ها</h2>\n` +
      `    <p>کلیه پرداخت‌ها به هلدینگ تبلیغاتی <strong>کارآفرینان برتر سپهر آراد «ترمینال ادز»</strong> فقط باید از طریق درگاه اینترنتی موجود در سامانه انجام شود.</p>\n` +
      `\n` +
      `    <div class="note">\n` +
      `      <strong>توجه:</strong> در صورت واریز به حساب شخص یا شرکت دیگر، ترمینال ادز هیچ مسئولیت قانونی یا شرعی ندارد.\n` +
      `    </div>`,
  en: `<h1>Regulations</h1>\n` +
      `\n` +
      `    <p><strong>Dear user,</strong> before using the services, please read the following rules and conditions carefully.</p>\n` +
      `\n` +
      `    <h2>General</h2>\n` +
      `    <p>Membership and creating a user account on the Terminal Ads website is free of charge. Individuals must go to the registration section to sign up. Registration and completing the process constitutes full awareness and acceptance of the rules and regulations of the Terminal Ads website.</p>\n` +
      `\n` +
      `    <p>Any person who uses the services of Terminal Ads in any form or to any extent is deemed to be fully aware of and in complete acceptance of the website’s rules and regulations, and subject to them.</p>\n` +
      `\n` +
      `    <p>Each person may only have one user account. If it is later determined that a person has more than one account, Terminal Ads may delete those accounts and terminate the user’s access to their profile. The user has no right to object to this action.</p>\n` +
      `\n` +
      `    <p>Individuals must use their own real and accurate identity information when registering. Terminal Ads assumes no responsibility in cases of violation of this requirement.</p>\n` +
      `\n` +
      `    <p>If it becomes clear that a person has used a fake name or fraudulent account to purchase products or use the website, Terminal Ads may delete that account. In such cases, any payments made will not be refunded.</p>\n` +
      `\n` +
      `    <p>Terminal Ads makes every effort to keep its pages and content updated. The website may, for any reason, freely remove or temporarily/permanently restrict access to specific pages. Users have no right to object to such actions.</p>\n` +
      `\n` +
      `    <p>User information is protected by the website. Terminal Ads makes every effort to safeguard users’ information and employs appropriate facilities and infrastructure for this purpose.</p>\n` +
      `\n` +
      `    <h2>User Responsibilities</h2>\n` +
      `    <p>The user must take care to protect their information, such as username, contact details, and passwords, and keep them confidential. If the user fails to do so and their information is disclosed, Terminal Ads bears no responsibility, and all consequences shall be borne by the user.</p>\n` +
      `\n` +
      `    <p>Users must not share their account with any other person for any purpose. Terminal Ads provides services only to the account holder. If any issues arise due to simultaneous use of one account or transferring it to others, the user bears full responsibility, and Terminal Ads has no liability. If it becomes clear that multiple people are using one account simultaneously, Terminal Ads may take any action it deems necessary.</p>\n` +
      `\n` +
      `    <h2>Communications</h2>\n` +
      `    <p>By registering on the website, providing an email address in various sections, or submitting other contact information such as a mobile phone number, the user grants Terminal Ads the right to send emails or SMS messages whenever deemed appropriate. Receiving these messages is not mandatory, and Terminal Ads provides users the option to unsubscribe from them.</p>\n` +
      `\n` +
      `    <p>The contact information registered by the user on the website (such as phone number and email) is the only valid and recognized contact information. All correspondence and follow-ups will be made through these details, and Terminal Ads is not responsible for any other contact methods.</p>\n` +
      `\n` +
      `    <p>If any of this information changes, the user must inform the website. If the user fails to provide updated information, Terminal Ads bears no responsibility.</p>\n` +
      `\n` +
      `    <p>The user may communicate with Terminal Ads through the contact methods provided on the “Contact Us” page.</p>\n` +
      `\n` +
      `    <h2>General Rules and Conditions for All Terminal Ads Services</h2>\n` +
      `    <ul>\n` +
      `      <li>Advertisers must comply with the regulations, standards, and guidelines issued by the Islamic Republic of Iran.</li>\n` +
      `      <li>You must comply with e-government laws, including internet security laws, computer information systems security laws (PRC), and internet confidentiality laws.</li>\n` +
      `      <li>You commit to comply with all future laws passed regarding advertising on websites.</li>\n` +
      `      <li>The user is responsible for any adverse effects caused by posting unauthorized advertisements in the panel, as well as any liabilities before inspection and supervisory bodies.</li>\n` +
      `      <li>Terminal Ads has the right, if necessary or at the request of legal authorities and supervisory bodies, to disclose advertisements and block them, even before notifying users.</li>\n` +
      `    </ul>\n` +
      `\n` +
      `    <h2>Advertisement Content — Compliance Principles</h2>\n` +
      `    <p>All advertisement content must comply with the following five principles:</p>\n` +
      `    <ol>\n` +
      `      <li>Must not conflict with the principles of Islam or the Constitution of the Islamic Republic of Iran.</li>\n` +
      `      <li>Must not disturb or mislead public opinion.</li>\n` +
      `      <li>Must not disrupt public order or peace.</li>\n` +
      `      <li>Must not harm public morality.</li>\n` +
      `      <li>Must not conflict with the cultural, social, or economic policies of the country.</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <p>The user is obligated to provide accurate information. If false information is provided, in addition to account suspension, Terminal Ads reserves the right to pursue necessary legal action.</p>\n` +
      `\n` +
      `    <p>Phone numbers registered in this system cannot, under any circumstances, be transferred to any other person or company and may only be used by the registered user.</p>\n` +
      `\n` +
      `    <h2>Required Documents</h2>\n` +
      `    <p>For using the Terminal Ads system, the following documents must match:</p>\n` +
      `    <ol>\n` +
      `      <li>National ID code</li>\n` +
      `      <li>The phone number associated with that National ID</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <h2>Important Note on Payments</h2>\n` +
      `    <p>Dear users, please be informed that all payments to the “Terminal Ads” advertising holding company <strong>Karafarinan Bartar Sepehr Arad</strong> must only be made through the online payment gateway available on the system.</p>\n` +
      `\n` +
      `    <div class="note">\n` +
      `      <strong>Warning:</strong> If you transfer money to any other individual or company account, Terminal Ads assumes no legal or religious responsibility.\n` +
      `    </div>\n`,
  ar: `<h1>اللوائح</h1>\n` +
      `\n` +
      `    <p><strong>المستخدم العزيز،</strong> قبل استخدام الخدمات، يرجى قراءة القواعد والشروط التالية بعناية.</p>\n` +
      `\n` +
      `    <h2>عام</h2>\n` +
      `    <p>العضوية وإنشاء حساب مستخدم على موقع ترمينال آدز مجانية. يجب على الأفراد الانتقال إلى قسم التسجيل للانضمام. التسجيل واستكمال العملية يعني الاطلاع الكامل والموافقة الكاملة على القوانين واللوائح الخاصة بموقع ترمينال آدز.</p>\n` +
      `\n` +
      `    <p>أي شخص يستخدم خدمات ترمينال آدز بأي شكل أو لأي قدر يعتبر على دراية كاملة بالقوانين واللوائح الخاصة بالموقع، ويوافق عليها بالكامل ويخضع لها.</p>\n` +
      `\n` +
      `    <p>يمكن لكل شخص امتلاك حساب واحد فقط. إذا تبيّن لاحقًا أن شخصًا يمتلك أكثر من حساب، يحق لترمينال آدز حذف هذه الحسابات وقطع وصول المستخدم إلى ملفه الشخصي، وليس للمستخدم أي حق في الاعتراض.</p>\n` +
      `\n` +
      `    <p>يجب على الأفراد استخدام معلوماتهم وهويتهم الحقيقية عند التسجيل. ترمينال آدز لا تتحمل أي مسؤولية في حال مخالفة ذلك.</p>\n` +
      `\n` +
      `    <p>إذا تبيّن أن شخصًا ما استخدم اسمًا مزيفًا أو حسابًا وهميًا لشراء منتجات أو لاستخدام الموقع، يحق لترمينال آدز حذف الحساب، وفي هذه الحالة لن يتم استرداد المبالغ المدفوعة.</p>\n` +
      `\n` +
      `    <p>يبذل موقع ترمينال آدز جهده لتحديث صفحاته ومحتواه. ويحق للموقع، لأي سبب، حذف أو تعطيل الوصول مؤقتًا أو دائمًا إلى صفحات محددة دون أن يكون للمستخدمين حق الاعتراض.</p>\n` +
      `\n` +
      `    <p>معلومات المستخدمين تبقى محفوظة لدى الموقع، ويبذل ترمينال آدز أقصى جهده لحمايتها باستخدام البنية التحتية والإمكانيات اللازمة.</p>\n` +
      `\n` +
      `    <h2>مسؤوليات المستخدم</h2>\n` +
      `    <p>يجب على المستخدم الحفاظ على بياناته مثل اسم المستخدم ومعلومات الاتصال وكلمات المرور بشكل سري. في حال الإخلال بذلك، لا يتحمل ترمينال آدز أي مسؤولية، وتبقى جميع العواقب على عاتق المستخدم.</p>\n` +
      `\n` +
      `    <p>لا يجوز للمستخدم تسليم حسابه لأي شخص آخر لأي سبب. ترمينال آدز يقدم خدماته فقط لصاحب الحساب. في حال حدوث مشكلة بسبب الاستخدام المشترك أو نقل الحساب، يتحمل المستخدم كامل المسؤولية، ويحق لترمينال آدز اتخاذ الإجراءات المناسبة إذا تبين استخدام حساب واحد من قِبل عدة أشخاص.</p>\n` +
      `\n` +
      `    <h2>الاتصالات</h2>\n` +
      `    <p>من خلال التسجيل في الموقع أو تقديم البريد الإلكتروني أو رقم الهاتف المحمول، يمنح المستخدم ترمينال آدز الحق في إرسال رسائل بريد إلكتروني أو رسائل نصية عند الحاجة. يمكن للمستخدم إلغاء الاشتراك إذا رغب.</p>\n` +
      `\n` +
      `    <p>معلومات الاتصال التي يسجلها المستخدم (الهاتف أو البريد الإلكتروني) هي الوحيدة المعتمدة لدى الموقع. جميع المراسلات والمتابعات تتم عبرها، ولا يتحمل ترمينال آدز أي مسؤولية تجاه معلومات أخرى.</p>\n` +
      `\n` +
      `    <p>في حال تغيير أي من هذه المعلومات، يجب على المستخدم إبلاغ الموقع. إذا لم يفعل، لا يتحمل ترمينال آدز أي مسؤولية.</p>\n` +
      `\n` +
      `    <p>يمكن للمستخدم التواصل مع ترمينال آدز عبر قنوات الاتصال المذكورة في صفحة «اتصل بنا».</p>\n` +
      `\n` +
      `    <h2>القواعد والشروط العامة لجميع خدمات ترمينال آدز</h2>\n` +
      `    <ul>\n` +
      `      <li>يجب على المعلنين الالتزام بالأنظمة والمعايير والتعليمات الصادرة عن جمهورية إيران الإسلامية.</li>\n` +
      `      <li>يجب الالتزام بقوانين الحكومة الإلكترونية مثل قوانين أمان الإنترنت، وقوانين أمان أنظمة المعلومات، وقوانين سرية الإنترنت.</li>\n` +
      `      <li>يتعهد المستخدم بالالتزام بجميع القوانين المستقبلية المتعلقة بالإعلانات على المواقع الإلكترونية.</li>\n` +
      `      <li>المستخدم مسؤول عن أي أضرار أو عواقب ناجمة عن نشر إعلانات غير قانونية.</li>\n` +
      `      <li>يحق لترمينال آدز، إذا لزم الأمر أو بناءً على طلب السلطات القانونية، كشف الإعلانات أو حجبها حتى قبل إخطار المستخدمين.</li>\n` +
      `    </ul>\n` +
      `\n` +
      `    <h2>محتوى الإعلانات — المبادئ الخمسة</h2>\n` +
      `    <ol>\n` +
      `      <li>ألا يتعارض مع مبادئ الإسلام أو دستور جمهورية إيران الإسلامية.</li>\n` +
      `      <li>ألا يؤدي إلى تشويش الرأي العام.</li>\n` +
      `      <li>ألا يخل بالنظام العام أو السكينة العامة.</li>\n` +
      `      <li>ألا يضر بالأخلاق العامة.</li>\n` +
      `      <li>ألا يتعارض مع السياسات الثقافية أو الاجتماعية أو الاقتصادية للبلاد.</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <p>يلتزم المستخدم بإدخال بيانات صحيحة. في حال تقديم بيانات مزيفة، يحق لترمينال آدز إيقاف الحساب واتخاذ إجراءات قانونية.</p>\n` +
      `\n` +
      `    <p>الأرقام المسجلة في هذا النظام غير قابلة للتحويل لأي شخص أو شركة أخرى، ولا يمكن استخدامها إلا من قبل المستخدم المسجل.</p>\n` +
      `\n` +
      `    <h2>المستندات المطلوبة</h2>\n` +
      `    <p>لاستخدام نظام ترمينال آدز، يجب أن تتطابق المستندات التالية:</p>\n` +
      `    <ol>\n` +
      `      <li>الرمز الوطني</li>\n` +
      `      <li>الرقم المرتبط بهذا الرمز الوطني</li>\n` +
      `    </ol>\n` +
      `\n` +
      `    <h2>ملاحظة مهمة بخصوص الدفع</h2>\n` +
      `    <p>نُعلم مستخدمينا الأعزاء أن جميع المدفوعات إلى شركة الإعلانات <strong>كارآفرينان برتر سبهـر آراد «ترمينال آدز»</strong> يجب أن تتم حصراً عبر بوابة الدفع الإلكترونية المتاحة في النظام.</p>\n` +
      `\n` +
      `    <div class="note">\n` +
      `      <strong>تحذير:</strong> في حال التحويل إلى أي حساب آخر، لا يتحمل ترمينال آدز أي مسؤولية قانونية أو شرعية.\n` +
      `    </div>\n`,
};